import React, { useState } from 'react';
import { SearchInput } from '../';
import styles from './SearchPanel.module.css';
import DefinitionInput from '../DefinitionInput';
const SearchPanel = /*#__PURE__*/React.memo(({
  searchText,
  suggestionClickCallback,
  currentItem,
  setCurrentItem,
  isTextSelected
}) => {
  const [searchValue, setSearchValue] = useState(searchText);
  const [isDefinitionEditable, setDefinitionEditable] = useState(false);
  const suggestionClick = ({
    id,
    term,
    uuid,
    definition,
    business_line
  }, isPreview) => {
    suggestionClickCallback({
      id,
      term,
      uuid,
      definition,
      business_line
    }, isPreview);
    if (id === 0) {
      setDefinitionEditable(true);
    } else {
      setDefinitionEditable(false);
    }
    setCurrentItem({
      id,
      term,
      uuid,
      definition,
      business_line
    });
  };
  const handleChangeDefinition = definition => {
    setCurrentItem({
      ...currentItem,
      definition: definition
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.searchContainer
  }, /*#__PURE__*/React.createElement(SearchInput, {
    searchValue: searchValue,
    suggestionClickCallback: suggestionClick,
    setSearchValue: setSearchValue,
    isTextSelected: isTextSelected
  }), /*#__PURE__*/React.createElement(DefinitionInput, {
    setDefinition: handleChangeDefinition,
    definition: currentItem?.definition,
    disabled: !isDefinitionEditable,
    term: currentItem?.term
  })));
});
export default SearchPanel;